<template>
  <div>
    <div class="report-container" v-if="htmlContent" v-html="htmlContent"></div>

    <!-- Floating Scroll Buttons -->
<div class="floating-bottom-nav">
  <div @click="activateMenuItem('home')" title="Go Home">&#8962;</div>
  <div @click="activateMenuItem('chart')" title="Go Back">&#8592;</div>
  <div @click="scrollToTop" title="Scroll to Top">&#8679;</div>
  <div @click="scrollToBottom" title="Scroll to Bottom">&#8681;</div>
</div>

  </div>
</template>


<script>
import ApiBaseUrl from "@/http-api-base-url";  
import { queryString, criteriaToken } from "../util.js";
export default {
	components: {  },
	props: {
		horoscope : {
			type: Object
		}
	},  
  data() {
    return {
      htmlContent: '<div style="display:flex;justify-content:center;align-items:center;height:100vh;margin:0;"><img src="https://www.vedicastrologyreport.com/images/complimentary_report_share.jpg" alt="Generating your personalized report..." style="max-width:100%;height:auto;"></div>',
      htmlUrl: '',      
    };
  },
  async mounted() {
    if (this.horoscope.criteria) {
      this.htmlUrl =  ApiBaseUrl() + '/site/var/api/html/basic/report/stream?' + this.queryString(this.horoscope.criteria) + "&ct=" + this.getCriteriaToken(this.horoscope.criteria);
      const response = await fetch(this.htmlUrl);
      this.htmlContent = await response.text();
      this.scrollToTop();
    }
  },
  methods: {
    activateMenuItem(activeMenuItem) {
      this.$emit('activeMenuItem', activeMenuItem);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToBottom() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },
    queryString: function (obj) {
      return queryString(obj);
    },
    getCriteriaToken: function() {
            return criteriaToken(this.horoscope.criteria);
    },
  }
};
</script>



<style scoped>
.report-container {
  width: 100%;
  margin: auto;
}

#home-btn,
#back-btn,
#scroll-top-btn,
#scroll-bottom-btn {
  position: fixed;
  right: 20px;
  width: 45px;
  height: 45px;
  font-size: 24px;
  background-color: #344E41;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  cursor: pointer;
  z-index: 1000;
}

#home-btn { bottom: 200px; }
#back-btn { bottom: 140px; }
#scroll-top-btn { bottom: 80px; }
#scroll-bottom-btn { bottom: 20px; }

.floating-nav {
  position: fixed;
  right: 20px;
  bottom: 90px; /* clears contact icon */
  display: flex;
  flex-direction: column;
  gap: 14px;
  z-index: 1000;
}

.floating-nav > div {
  width: 45px;
  height: 45px;
  font-size: 24px;
  background-color: #344E41;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  cursor: pointer;
}

.floating-bottom-nav {
  position: fixed;
  bottom: 20px;              /* clears contact icon */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 14px;
  z-index: 1000;
}

/* Reuse your existing button styling */
.floating-bottom-nav > div {
  width: 45px;
  height: 45px;
  font-size: 24px;
  background-color: #344E41;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  cursor: pointer;
}

#scroll-top-btn {
  bottom: 80px;
}

#scroll-bottom-btn {
  bottom: 20px;
}

#scroll-top-btn:hover,
#scroll-bottom-btn:hover {
  background-color: #3a5a40;
}

</style>
